import api from './api';
import { Friedhof, CreateFriedhofRequest, UpdateFriedhofRequest } from '../types';

export const friedhofService = {
  getAll: async (): Promise<Friedhof[]> => {
    const response = await api.get('/friedhoefe');
    return response.data;
  },
  getById: async (id: number): Promise<Friedhof> => {
    const response = await api.get(`/friedhoefe/${id}`);
    return response.data;
  },
  create: async (data: CreateFriedhofRequest): Promise<Friedhof> => {
    const response = await api.post('/friedhoefe', data);
    return response.data;
  },
  update: async (id: number, data: UpdateFriedhofRequest): Promise<Friedhof> => {
    const response = await api.put(`/friedhoefe/${id}`, data);
    return response.data;
  },
  delete: async (id: number): Promise<void> => {
    await api.delete(`/friedhoefe/${id}`);
  }
};

export default friedhofService;
